import { render } from "./ReleaseNotesModal.vue?vue&type=template&id=31f48088&scoped=true"
import script from "./ReleaseNotesModal.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesModal.vue?vue&type=script&lang=js"

import "./ReleaseNotesModal.vue?vue&type=style&index=0&id=31f48088&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f48088"]])

export default __exports__